import React from 'react';

const NoInputComponent = () => {
  return <div />;
};

export default NoInputComponent;
